import PageLayout from "components/molecules/PageLayout";
import AppPaths from "constants/appPaths";
import DataObjectUUID from "containers/DataObjectUUID";
import { Redirect, useParams } from "react-router-dom";

const DataObjectUUIDPage = ({ tenant, ...props }) => {
    const { uuid } = useParams();

    return (
        <>
            {tenant && tenant.name && tenant.name === uuid ? (
                <Redirect to={AppPaths.TENANT_HOME.replace(":tenant", tenant.name)}></Redirect>
            ) : (
                <PageLayout
                    key={uuid}
                    mainContent={({ setBreadcrumbNavigationItems }) => {
                        return <DataObjectUUID dataObjectId={uuid} tenant={tenant?.name}></DataObjectUUID>;
                    }}
                ></PageLayout>
            )}
        </>
    );
};

export default DataObjectUUIDPage;
